<template>
  <v-container>
    <v-row>
      <v-col cols='12' md='4'>
        <basics
          v-if='client'
          :client='client'
          @update='updateClient'
        ></basics>
      </v-col>
      <v-col cols='12' md='4'>
        <client-details
          v-if='client'
          :client='client'
          @update='updateClient'
        ></client-details>
      </v-col>
      <v-col cols='12' md='4'>
        <works-for
          v-if='client.is_company'
          :client='client'
        ></works-for>
        <client-contacts
          class='mt-6'
          v-if='client.is_company'
          :client='client'
        ></client-contacts>
        <client-contacts-reversed
          v-if='!client.is_company'
          :client='client'
        ></client-contacts-reversed>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Basics from './Basics'
import Details from './Details'
import WorksFor from './WorksFor'
import ClientContacts from './ClientContacts'
import ClientContactsReversed from './ClientContactsReversed'
import formRules from '@/mixins/formRules'

export default {
  name: 'client-overview',
  mixins: [formRules],
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    
  }),
  methods: {
    updateClient (client) {
      this.$emit('update', client)
    }   
  },
  components: {
    'basics': Basics,
    'client-details': Details,
    'client-contacts': ClientContacts,
    'client-contacts-reversed': ClientContactsReversed,
    'works-for': WorksFor
  }
}
</script>
